import React from 'react';

import { fg } from '@atlaskit/platform-feature-flags';
import { Subscriber } from '@atlaskit/rovo-triggers';

import { useChatContextStoreActions } from './store';

export const ChatContextSubscriber = () => {
	const {
		setEditorContext,
		setBrowserContext,
		setJiraWorkflowContext,
		setDashboardContext,
		setAIFeatureContext,
	} = useChatContextStoreActions();

	return (
		<Subscriber
			topic="ai-mate"
			onEvent={async (payload) => {
				// TODO https://product-fabric.atlassian.net/browse/AIM-1989 implement experience tracker
				try {
					switch (payload.type) {
						case 'editor-context-payload':
							setEditorContext(payload.data);
							break;
						case 'browser-context-payload':
							setBrowserContext(payload.data);
							break;
						case 'dashboard-insights-actions':
							fg('platform_avp_enable_dashboard_context_event_pubsub') &&
								setDashboardContext(payload.data);
							break;
						case 'jira-workflow-wizard-actions': {
							fg('enable_jira_workflow_wizard_agent_in_wf_editor') &&
								setJiraWorkflowContext(payload.data);
							break;
						}
						case 'set-message-context': {
							if (fg('platform_set_message_context')) {
								setAIFeatureContext(payload.data);
							}
							break;
						}
						default:
					}
				} catch (error) {}
			}}
		/>
	);
};
